var _g, _rect, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 504.207,
    height: 207.162,
    viewBox: "0 0 504.207 207.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timmerwerken",
    transform: "translate(-506.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M210.671,85.289V70.849l5.314-7.785V85.289Zm5.314-30.144q-6.58,10.45-6.642,10.7l-8.3,12.287h-.189l-9.5-14.254v21.41h-5.33V55.145h5.705l9.251,14.44,9.3-14.44Z",
    transform: "translate(410.91 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M223.131,85.289V70.849l5.314-7.785V85.289Zm5.314-30.144q-6.58,10.45-6.642,10.7l-8.3,12.287h-.189l-9.5-14.254v21.41H198.5V55.145h5.689l9.251,14.44,9.315-14.44Z",
    transform: "translate(438.461 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M212.113,59.958h22.552V55.145H212.113Zm0,25.331H234.6V80.476H212.113Zm0-12.861h20.331V67.692H212.113Z",
    transform: "translate(468.531 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M249.693,85.289h-6.267l-7.409-10.515h-6.655V85.289h-5.253V70.1h13.05a6.877,6.877,0,0,0,4.563-1.405,4.453,4.453,0,0,0,1.64-3.671,4.528,4.528,0,0,0-1.64-3.8,7.491,7.491,0,0,0-4.627-1.264H224.109V55.145h13.426a15.652,15.652,0,0,1,4.688.7,10.177,10.177,0,0,1,3.546,1.893,8.714,8.714,0,0,1,2.221,2.984,10.1,10.1,0,0,1,.751,3.985,9.719,9.719,0,0,1-.565,3.421,7.607,7.607,0,0,1-1.454,2.6,9.516,9.516,0,0,1-2.281,1.967,15.459,15.459,0,0,1-2.92,1.2Z",
    transform: "translate(495.028 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M240.774,55.145l2.657,11.594,3.924,18.55h-5.314l-6.155-30.144Zm20.521,0h4.675L260.153,76.93l-2.407-9.177Zm-7.672,9.248.639,2.346,4.688,18.55h-5.388l-3.1-13.047-1.2,4.184-1.906-8.484,1.014-3.549.125-.25,2.721-9,2.031,7.656Z",
    transform: "translate(521.044 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M249.523,59.958h22.552V55.145H249.523Zm0,25.331H272V80.476H249.523Zm0-12.861h20.331V67.692H249.523Z",
    transform: "translate(551.165 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M287.1,85.289h-6.267l-7.409-10.515H266.77V85.289h-5.25V70.1h13.047a6.817,6.817,0,0,0,4.55-1.405,4.429,4.429,0,0,0,1.656-3.671,4.5,4.5,0,0,0-1.656-3.8,7.418,7.418,0,0,0-4.614-1.264H261.52V55.145h13.423a15.652,15.652,0,0,1,4.688.7,10.221,10.221,0,0,1,3.549,1.893,8.746,8.746,0,0,1,2.217,2.984,10.1,10.1,0,0,1,.751,3.985,9.794,9.794,0,0,1-.562,3.421,7.669,7.669,0,0,1-1.457,2.6,9.705,9.705,0,0,1-2.281,1.967,15.459,15.459,0,0,1-2.92,1.2Z",
    transform: "translate(577.664 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M300.489,85.228H294.1l-7.534-9.251,3.61-3.924Zm-7.034-30.083h6.97L279.093,78.133v7.095h-5.2V55.145h5.2V70.021Z",
    transform: "translate(604.99 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M286.934,59.958H309.47V55.145H286.934Zm0,25.331h22.475V80.476H286.934Zm0-12.861h20.331V67.692H286.934Z",
    transform: "translate(633.801 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M298.832,85.289V61.736l5.253,7.409V85.289Zm21.021-30.144h5.189V85.289h-4.361l-21.41-30.144h5.7l14.88,20.832Z",
    transform: "translate(660.082 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M171.5,85.289h5.314V65.022H171.5Zm-9.562-30.144v4.938H186.38V55.145Z",
    transform: "translate(357.7 121.808)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M177.387,55.125V85.4h5.327V55.125Z",
    transform: "translate(391.826 121.765)",
    fill: "#101820"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Horizontal_line",
    "data-name": "Horizontal line",
    width: 504.207,
    height: 3.536,
    transform: "translate(0 143.209)",
    fill: "#101820"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Malo",
    transform: "translate(-506.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M310.758,2.415V.348H276.349L240.525,86.185,202.458.348H164.552V3.053c4.627,0,14.655,1.595,14.655,10.355V83.477c0,18.313-9.553,31.062-21.336,31.062v2.23H201.98v-2.23c-10.191,0-20.707-13.227-20.707-31.226V14.836l45.075,101.933h4.775L274.279,12.606l.164,90.625c0,9.864-5.1,11.456-11.3,11.456v2.083h47.62v-2.083c-6.219,0-11.157-1.592-11.157-11.456V13.883c0-9.877,4.464-11.469,11.157-11.469",
    transform: "translate(348.717 0.769)",
    fill: "#7a7256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M312.97,103.969,272.358.3s-12.425,11.154-26.274,11.947a21.577,21.577,0,0,1,9.389,12.9c.475,1.592-25.158,65.458-26.123,68.163-3.809,8.763-11.783,21.66-20.858,21.5v2.083h42.043V114.8c-7.647,0-22.138-11.3-16.4-27.06l4.3-11.318h36.94l9.4,24.054c3.507,8.911.16,14.324-5.253,14.324v2.083h42.354V114.8c-5.089,0-8.911-10.83-8.911-10.83M239.227,74.037l17.687-45.223,17.674,45.223Z",
    transform: "translate(460.532 0.656)",
    fill: "#7a7256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M340.453,80.769c-5.9,21.987-29.945,33.918-47.469,33.918-4.775,0-9.864-3.183-9.864-11.456V13.883c0-9.877,4.451-11.469,11.3-11.469V.348H246.809V2.415c6.2,0,11.3,1.431,11.3,11.469v89.348c0,9.864-5.1,11.456-11.3,11.456v2.083H340.29l3.5-36Z",
    transform: "translate(545.17 0.769)",
    fill: "#7a7256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M392.284,59.727c0,32.968-27.388,59.717-56.219,59.717s-56.053-26.749-56.053-59.717C280.012,26.6,307.236,0,336.065,0s56.219,26.6,56.219,59.727m-28.354-.8c0-31.209-7.156-56.855-27.866-56.855-20.38,0-27.712,25.645-27.712,56.855s7.332,58.45,27.712,58.45c20.71,0,27.866-27.237,27.866-58.45",
    transform: "translate(618.511)",
    fill: "#7a7256"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.fb56dc08397a6e96172f4575f29b8bf0.svg";
export { ForwardRef as ReactComponent };